import {
  getSimple,
  putSimple,
  postSimple,
  delSimple,
  del,
  get,
  put,
  post
} from '../configApi'
export async function getLive(query) {
  return await getSimple(`/livestreamv2/`, query)
}
export async function getLiveDetail(param) {
  return await getSimple(`/livestreamv2/${param}/admin`)
}

export async function insertLive(body){
  return await postSimple(`/livestreamv2`, body)
}
export async function updateLive(id, body) {
  return await putSimple(`/livestreamv2/${id}`, body)
}
export async function deleteLive(id){
  return await delSimple(`/livestreamv2/${id}`)
}

export async function stopLiveStream(id){
  return await postSimple(`/livestreamv2/${id}/end`)
}
//quiz
// export async function getListQuiz(params) {
//   return await get(`/livestream/live/listquiz`, params)
// }
export async function getListQuiz(streamId) {
  return await getSimple(`/livestreamv2/${streamId}/quiz/`)
}
export async function getQuiz(streamId, quizId) {
  return await getSimple(`/livestreamv2/${streamId}/quiz/${quizId}`)
}
export async function insertQuiz(streamId, body) {
  return await postSimple(`/livestreamv2/${streamId}/quiz/`, body)
}
export async function updateQuiz(streamId, quizId, body) {
  return await putSimple(`/livestreamv2/${streamId}/quiz/${quizId}`, body)
}
export async function deleteQuiz(streamId, quizId) {
  return await del(`/livestreamv2/${streamId}/quiz/${quizId}`)
}
export async function sendQuiz(streamId, quizId, body){
  return await postSimple(`/livestreamv2/${streamId}/quiz/${quizId}/notify`, body)
}
export async function getListQuizReport(streamId) {
  return await getSimple(`/livestreamv2/${streamId}/quiz/report`)
}
//choice
export async function insertChoice(streamId, quizId, body) {
  return await postSimple(`/livestreamv2/${streamId}/quiz/${quizId}/choice`, body)
}
export async function updateChoice(streamId, quizId, choiceId, body) {
  return await putSimple(`/livestreamv2/${streamId}/quiz/${quizId}/choice/${choiceId}`, body)
}
export async function deleteAns(streamId, quizId, choiceId) {
  return await del(`/livestreamv2/${streamId}/quiz/${quizId}/choice/${choiceId}`)
}

//Url
export async function getListUrl(streamId) {
  return await getSimple(`/livestreamv2/${streamId}/media/url`)
}
export async function insertURL(streamId, body) {
  return await postSimple(`/livestreamv2/${streamId}/media/url`, body)
}
export async function updateURL(streamId, urlId, body) {
  return await putSimple(`/livestreamv2/${streamId}/media/url/${urlId}`, body)
}
export async function deleteUrl(streamId, urlId) {
  return await del(`/livestreamv2/${streamId}/media/url/${urlId}`)
}

//Pdf

export async function getListPdf(streamId) {
  return await getSimple(`/livestreamv2/${streamId}/media/pdf/`)
}
export async function insertPdf(streamId, body) {
  return await postSimple(`/livestreamv2/${streamId}/media/pdf`, body)
}
export async function updatePdf(streamId, pdfId, body) {
  return await putSimple(`/livestreamv2/${streamId}/media/pdf/${pdfId}`, body)
}
export async function deletePdf(streamId, pdfId) {
  return await del(`/livestreamv2/${streamId}/media/pdf/${pdfId}`)
}

//check name
export async function getCheckStudentList(streamId) {
  return await getSimple(`/livestreamv2/${streamId}/checkin`)
}
export async function requestCheckStudent(streamId, body){
  return await postSimple(`/livestreamv2/${streamId}/checkin`, body)
}

//chat room
export async function getChatRoomList(body) {
  return await get(`/livestream/chatroom/list/list`, body)
}
export async function insertChatRoom(body) {
  return await post(`/livestream/chatroom/manage/insert`, body)
}
export async function updateChatRoom(body) {
  return await put(`/livestream/chatroom/manage/update`, body)
}
export async function deleteChatRoom(body) {
  return await del(`/livestream/chatroom/manage/delete`, body)
}
//Image
export async function getListImage(streamId) {
  return await getSimple(`/livestreamv2/${streamId}/media/image`)
}
export async function insertImage(streamId, body) {
  return await post(`/livestreamv2/${streamId}/media/image`, body)
}
export async function deleteImage(streamId, imageId) {
  return await del(`/livestreamv2/${streamId}/media/image/${imageId}`)
}

// report

export async function reportLeaderBoard(streamId, query) {
  return await getSimple(`/livestreamv2/${streamId}/quiz/leader`, query)
}

// dashboard
export async function getTotalLearner(streamId){
  return await getSimple(`/livestreamv2/${streamId}/dashboard/header`)
}
export async function getJoinedLearner(streamId){
  return await getSimple(`/livestreamv2/${streamId}/dashboard/learner`)
}
export async function getRegisteredLearner(streamId){
  return await getSimple(`/livestreamv2/${streamId}/dashboard/register`)
}
export async function getOnlineLearner(streamId){
  return await getSimple(`/livestreamv2/${streamId}/dashboard/online`)
}
export async function getMessageLearner(streamId){
  return await getSimple(`/livestreamv2/${streamId}/dashboard/mail`)
}
export async function getAnswerStudentList(detail, query){
  return await getSimple(`/livestreamv2/${detail.liveId}/quiz/${detail.quizId}/choice/${detail.choiceId}`, query)
}

// don't used

export async function getLiveStreamKey() {
  return await get(`/livestreamkey/list/teacher`)
}
export async function getLiveStreamStudio(data) {
  return await get(`/livestream/live/studio`, data)
}
export async function setLiveStreamKey(body){
  return await put(`/livestream/live/addkeystudio`, body)
}
export async function startLiveStream(body){
  return await get(`/livestream/live/startstream`, body)
}
export async function cancelLiveStream(body){
  return await get(`/livestream/live/clearkey`, body)
}

// export async function getTotalLearner(body){
//   return await get(`/livestream/report/studio/header`, body)
// }

// export async function sendQuiz(body){
//   return await put(`/livestream/live/sendquiz`, body)
// }
export async function reportQuiz(body) {
  return await get(`/livestream/report/quiz`, body)
}
export async function reportChoice(body) {
  return await get(`/livestream/report/choice`, body)
}
